import { memo } from 'react'

import { Cookies } from './Cookies'

export const CookiesCopy = memo(Cookies)
